/**
 * EcoF-Interactive-Tabs
 * Handles tab switching and lightbox functionality
 */

(function() {
  'use strict';

  function initLightbox(section) {
    const lightbox = section.querySelector('.ecof-lightbox');
    if (!lightbox) return;

    const lightboxImage = lightbox.querySelector('.ecof-lightbox__image');
    const lightboxCaption = lightbox.querySelector('.ecof-lightbox__caption');
    const closeBtn = lightbox.querySelector('.ecof-lightbox__close');
    const gridImages = section.querySelectorAll('.ecof-tab-grid-image[data-lightbox="true"]');

    if (gridImages.length === 0) return;

    gridImages.forEach(function(item) {
      item.addEventListener('click', function() {
        const gridItem = item.closest('.ecof-tab-grid-item');
        const img = item.querySelector('img');
        const caption = gridItem ? gridItem.querySelector('.ecof-tab-grid-caption') : null;
        const fullSrc = item.getAttribute('data-full-src');

        if (lightboxImage && fullSrc) {
          lightboxImage.src = fullSrc;
          lightboxImage.alt = img ? img.alt : '';
        }

        if (lightboxCaption) {
          lightboxCaption.textContent = caption ? caption.textContent : '';
        }

        lightbox.classList.add('active');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeLightbox);
    }

    lightbox.addEventListener('click', function(event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && lightbox.classList.contains('active')) {
        closeLightbox();
      }
    });
  }

  function initTabs(section) {
    const tabButtons = section.querySelectorAll('.ecof-tab-btn');
    const tabContents = section.querySelectorAll('.ecof-tab-content');

    if (tabButtons.length === 0 || tabContents.length === 0) return;

    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');

        tabButtons.forEach(function(btn) {
          btn.classList.remove('active');
        });

        tabContents.forEach(function(content) {
          content.classList.remove('active');
        });

        this.classList.add('active');

        const targetContent = section.querySelector('[data-content="' + targetTab + '"]');
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }

  function initSection(section) {
    initTabs(section);
    initLightbox(section);
  }

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.ecof-tabs-section');
    sections.forEach(initSection);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      if (section.classList.contains('ecof-tabs-section')) {
        initSection(section);
      }
    });
  }
})();
